import "../../assets/css/community-map.css";
import { useState, useContext, useEffect } from "react";
import StateContext from "../../state/stateContext";
import useQueryCommunityNews from "../Hooks/useQueryCommunityNews";
import useQueryChildData from "../Hooks/useQueryChildData";
import Image from "../Image/ImageShimmer";

export function CommunityMap() {
   const context = useContext(StateContext);
   const [imageStatus, setImageStatus] = useState("pending");
   const [imageUrl, setImageUrl] = useState("");
   const queryChildData = useQueryChildData(context);
   const queryCommunityNews = useQueryCommunityNews(context);

   useEffect(() => {
      if (queryChildData.isSuccess && imageStatus === "pending") {
         const { projectIdentifier } = queryChildData?.data || {};
         setImageStatus("loading");
         queryCommunityNews.request(projectIdentifier);
      } else if (queryCommunityNews.isError) {
         setImageStatus("error");
      }
   }, [queryChildData, imageUrl, queryCommunityNews]);

   useEffect(() => {
      if (queryCommunityNews.isSuccess && imageStatus === "loading") {
         const { latitude:lat, longitude:lon } = queryCommunityNews.parseDataFields([
            "latitude",
            "longitude"
         ], queryCommunityNews.data);

         const url = queryCommunityNews.getMapImage({
            lat, lon, width: "320", height: "220"
         });

         setImageUrl(url);
         setImageStatus("success");
      }
   }, [queryCommunityNews, imageStatus, setImageUrl, setImageStatus]);

   if (queryCommunityNews.isError) {
      // Do Not Display Map
      return null;
   }

   const loading = queryCommunityNews.isWaiting || ["pending", "loading"].includes(imageStatus);

   return (
      <Image 
         src={imageUrl} 
         alt="Project Map"
         className="community-map__image"
         shimmerProps={{height: "220px"}}
         showShimmer={loading}
      />
    );
}
  
export default CommunityMap;